import React, { useState, useEffect } from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import './flag.css'
import Flagimg from '../../assets/colored/critical-transformed-transformed.png'
import Flagimg1 from '../../assets/colored/warning-transformed.png'
import Flagimg2 from '../../assets/colored/green_(1)-transformed.png'
import Hexapi from '../../utility/HexAPI/Hexapi';
import GetImage from '../getimage/Getimage';
import { showConfirm } from '../../utility/showconfirm';
import Loader from '../loader/Loader';
import { showCustomSwal } from '../customswal/Customswal';


  const Flagmodal = ({ show, hide, ticketinfo,userId,empnameflag,empidflag,fetchData ,activitytypee = 1}) => {
    console.log(show);
  const [flagtype, setflagtype] = useState(-1);
  const [openremark, setopenremark] = useState("");
  const activitytype = activitytypee;
  const ticketdata = ticketinfo;
  const raisedbyid=userId
  const activityid = -1;
  const allocatedid=empidflag
  const[flagraised,setflagraised]=useState(true)
  const[confirmraised,setconfirmraised]=useState(false)
  const[confirmtext,setconfirmtext]=useState("")
  const [loading,setloading]=useState(false)
  const [shows,setshow]=useState(false)
  const [showdata,setshowdata]=useState(true)
  const [isRemarkEmpty, setIsRemarkEmpty] = useState(false);
  const [imagesLoaded, setImagesLoaded] = useState(false);

const flagStyles = {
  1: "redflag-2",
  2: "yellowflag-2",
  3: "greenflag-2",
};
  useEffect(() => {
    const loadImage = src => {
      return new Promise(resolve => {
        const img = new Image();
        img.src = src;
        img.onload = () => resolve();
      });
    };

    const preloadImages = async () => {
      await loadImage(Flagimg);
      await loadImage(Flagimg1);
      await loadImage(Flagimg2);
      setImagesLoaded(true); 
    };

    preloadImages(); 
  }, []);

  const handleflagtype=(type)=>{
    let typetext;
if(type == 1){
typetext= "critical flag" 
}else if(type == 2){
  typetext= "warning flag" 
}else if(type == 3){
typetext= "appreciate flag" 
}else{
typetext= "" 
}
return typetext
  }
  const handleflag = async() => {

    try {
       setshow(true)
    setloading(true)
    setconfirmraised(false)
    const obj = {
      query: `[dbo].[HRApp_Droid_Proc_AddFlag_Submit] @FlagType='{0}',@OpenRemarks='{1}',@RaisedByEmpID ='{2}',@AllocatedToEmpID ='{3}',@ActivityID ='{4}',@ActivityType ='{5}'`,
      queryArr: [`${flagtype}`, `${openremark}`, `${raisedbyid}`, `${allocatedid}`, `${activityid}`, `${activitytype}`]
    };

    const flagraised= await Hexapi(obj)
    console.log(flagraised,"hfbcadb")
     setloading(false)
if(flagraised && flagraised[""] && flagraised[""][0]){
 showConfirm({
    content:`${flagraised[''][0]['msg']}`,
    hideCancel:true,
    okText:'OK'
  }).then(()=>{
    if(fetchData){
fetchData()
    }
    
  })
}
    } catch (error) {
       if(error.message =="SQL Error occurred"){
      showCustomSwal("error occurred please try again")
    }
    }finally{
      setshow(false)
      // setshowdata(true)
      setconfirmraised(false)
    }
   

  }
  const handleraisedflag = async() => {
    if (openremark === "") {
      setIsRemarkEmpty(true);
      return;
    }
    setIsRemarkEmpty(false); 
    setshowdata(false);
    setconfirmraised(true);

      const para= `Are you sure you want to raise a ${ handleflagtype(flagtype)}
for ${empnameflag} ? `


  const confirmed=await showConfirm({
    content:para,
    hideCancel:false,
    okText:'YES',
    cancelText:"NO"
  })

  if(confirmed){
handleflag()
  }
  }

  const handlecritical = () => {
    setflagtype(1);
    setflagraised(false)
    console.log(flagtype,"liugfcxzezxc")
  };

  const handlewarning = () => {
    setflagtype(2);
    setflagraised(false)
  };

  const handlecappriciate = () => {
    setflagtype(3);
    setflagraised(false)
  };


  return (
    <div>

      { !imagesLoaded ? <Modal style={{backdropFilter:"blur(4px)" , backgroundColor:"#3333331a"}} centered show={show}>
        <Modal.Body>

        <div className='row'>
            <div style={{ color: '#23b8fb',fontWeight:"500" }} className='fs-5'>
              Select a Flag
            </div>
          </div>
        <div style={{ display: "flex", alignItems: "center" , justifyContent:"center", color: '#23b8fb' }}>
            <span style={{marginRight:"20px"}}> <Loader variant='info'/></span><h6>Loading images...</h6>
            </div>
            <div className='row text-center'>
            <div className='col-4'>
             
              <p className='redflag-1' onClick={handlecritical}>Critical</p>
            </div>
            <div className='col-4'>
          
              <p className='yellowflag-1' onClick={handlewarning}>Warning</p>
            </div>
            <div className='col-4'>
             
              <p className='greenflag-1' onClick={handlecappriciate}>Appreciate</p>
            </div>
          
      </div>
        </Modal.Body>
      </Modal> : (<>{showdata &&  <div>
      { flagraised ? 
     <Modal style={{backdropFilter:"blur(2px)" , backgroundColor:"#3333331a"}} centered show={show} onHide={hide}>
        <Modal.Body>
          <div className='row'>
            <div style={{ color: '#23b8fb',fontWeight:"500" }} className='fs-5'>
              Select a Flag
            </div>
          </div>
          <div className='row text-center'>
            <div className='col-4'>
              <img src={Flagimg} style={{cursor:"pointer"}} className=' img-fluid  '  onClick={handlecritical}/>
              <p className='redflag-1' onClick={handlecritical}>Critical</p>
            </div>
            <div className='col-4'>
            <img src={Flagimg1} style={{cursor:"pointer"}} className=' img-fluid '  onClick={handlewarning}/>
              <p className='yellowflag-1' onClick={handlewarning}>Warning</p>
            </div>
            <div className='col-4'>
              <img src={Flagimg2} style={{cursor:"pointer"}} className=' img-fluid ' onClick={handlecappriciate}/>
              <p className='greenflag-1' onClick={handlecappriciate}>Appreciate</p>
            </div>
          </div>
        </Modal.Body>
      </Modal>: 
       <Modal style={{backdropFilter:"blur(4px)" , backgroundColor:"#3333331a"}} centered show={show} onHide={hide}>
        <Modal.Body>
          <div className='row'>
<div className=''>
{ flagtype == 1 && 
<div className=' flag-display'>
<img style={{cursor:"pointer"}} src={Flagimg} className=' img-fluid  img-flag-size'/>
<p className='redflag-3'>Critical Flag</p>
</div>
}
{ flagtype == 2 &&

<div className=' flag-display'>
<img  style={{cursor:"pointer"}} src={Flagimg1} className=' img-fluid  img-flag-size' />
<p className='yellowflag-3'>Warning Flag</p>
  </div>

}
{ flagtype == 3 &&
<div  className=' flag-display'>
<img style={{cursor:"pointer"}} src={Flagimg2} className=' img-fluid  img-flag-size'/>
<p className='greenflag-3'>Appreciate Flag</p>
  </div>

}
</div>
          </div>
          <div className='d-flex gap-2 align-items-center mar-left'>
          <GetImage key={empidflag} top={true} width={"50px"} height={"50px"} imgID={empidflag} />
        <p>{empnameflag}</p>
          </div>
          <div>
          <div className="form-group mt-2 mar-left">
          <label htmlFor="Remarks" className={`remark-data ${
                        isRemarkEmpty ? "red-label" : ""
                      }`} >REASON <span className=' text-danger'>*</span></label>
          <input type="text" style={{paddingLeft:"0px" , border:"none"}} className="form-control mt-1" placeholder="Enter remarks" name='openremark' value={openremark} onChange={(e)=>{setopenremark(e.target.value)}}/>
        </div>

  {[1, 2, 3].includes(flagtype) && (
  <div className="big-all" onClick={handleraisedflag}>
    <p className={flagStyles[flagtype]}>RAISE</p>
  </div>
)}
          </div>
        </Modal.Body>
      </Modal>
      
      
      }
      </div>}

        <Modal style={{backdropFilter:"blur(px)" , backgroundColor:"#3333331a"}} centered show={loading} onHide={()=>{setloading(false)}}>
<Modal.Body> <div style={{ display: "flex", alignItems: "center" , justifyContent:"center", color: '#23b8fb' }}>
            <span style={{marginRight:"20px"}}> <Loader variant='info'/></span><h6>Raising...</h6>
      </div> 
</Modal.Body>
        </Modal> </>)}
    </div>
  );
};

export default Flagmodal;
